import { render } from "./GamePreviewCard.vue?vue&type=template&id=57d62c68&scoped=true"
import script from "./GamePreviewCard.vue?vue&type=script&lang=js"
export * from "./GamePreviewCard.vue?vue&type=script&lang=js"

import "./GamePreviewCard.vue?vue&type=style&index=0&id=57d62c68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57d62c68"]])

export default __exports__